module.exports = __webpack_public_path__ + "static/media/10x10no1.f95ae453.jpg";